import React from "react";
import "./App.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Stats from "./components/Stats";
import Views3D from "./components/Views3D";
import Overview from "./components/Overview";
import CarpetArea from "./components/CarpetArea";
import Elevation from "./components/Elevation";
import FloorPlans from "./components/FloorPlans";
import Location from "./components/Location";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App bg-neg-cream" id="top">
      <Navbar />
      <main>
        <Hero />
        <Stats />
        <Views3D />
        <Overview />
        <CarpetArea />
        <Elevation />
        <FloorPlans />
        <Location />
      </main>
      <Footer />
    </div>
  );
}

export default App;
